import { useState } from 'react'
import { WizardContent } from '@/components/wizard'
import PersonalInfo from './personal-info'
import FinancialInfo from './financial-info'
import Review from './review'
import Context from './context'

const DirectDepositWizardForm = ({
  currentStep,
  setCurrentStep,
  handleBack,
  onSuccess,
  isModal
}) => {
  const [formData, setFormData] = useState({})

  return (
    <Context.Provider value={{ formData, setFormData }}>
      <WizardContent currentStep={currentStep}>
        <PersonalInfo
          index="personal_info"
          setCurrentStep={setCurrentStep}
          handleBack={handleBack}
          isModal={isModal}
        />
        <FinancialInfo
          index="financial_info"
          setCurrentStep={setCurrentStep}
          handleBack={handleBack}
          isModal={isModal}
        />
        <Review index="review" handleBack={handleBack} onSuccess={onSuccess} isModal={isModal} />
      </WizardContent>
    </Context.Provider>
  )
}

export default DirectDepositWizardForm
